import { List, ListItem, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { Secure } from "lib/authorization/secure"
import { getScheduledTasks } from "routes/sfg20-admin/plugins/system-tab/scheduled-tasks-tab/controller/getScheduledTasks"
import { ScheduledTaskItem } from "routes/sfg20-admin/plugins/system-tab/scheduled-tasks-tab/ScheduledTaskItem"

export function ScheduledTasks() {
    const tasks = getScheduledTasks.useResults()
    return (
        <Secure demand="admin">
            {!tasks && <Typography>Loading Scheduled Tasks</Typography>}
            {tasks && <TasksTable tasks={tasks} />}
        </Secure>
    )
}

export function TasksTable({ tasks }) {
    const runningTasks = tasks.filter((t) => t.isRunning)
    return (
        <>
            {runningTasks.length} Tasks running
            <Repeat list={tasks} item={<ScheduledTaskItem />} pass="task" bind />
            <List>
                <ListItem>
                    &quot;Next Run After&quot; is the earliest a task will run again, subject to &quot;runs
                    between&quot; rules.
                </ListItem>
            </List>
        </>
    )
}
